import { createAction } from 'redux-actions-helpers';

export const setVisible = createAction('@@progress/SHOW_HIDE', (visible) => visible);



// WEBPACK FOOTER //
// ./src/blocks/progress-bar/actions.js